import { cn } from 'helpers/classnames';
import ReturnInstructionsSection from 'components/account/Returns/ReturnInstructionsSection';
import ReturnLabelOption from 'components/account/Returns/ReturnLabelOption';
import ReturnsAndExchangesUPSPickUpAddress from 'components/account/Returns/ReturnsAndExchangesUPSPickUpAddress';
import { PROVIDE_LABEL_OPTIONS } from 'constants/exchanges';
import BoxIcon from 'images/zappos/box-icon.svg';

// eslint-disable-next-line css-modules/no-unused-class
import css from 'styles/containers/returns/returnLabelOption.scss';

const PickupOption = ({ labelDelivery, UPSPickUpAddress, onReturnMethodSelect, showInstructions, showInstructionsHandler, displayOnly }) => {
  const checked = labelDelivery === PROVIDE_LABEL_OPTIONS.PICKUP;

  const expandedInfo = (
    <div className={css.additionalInfo}>
      <ReturnsAndExchangesUPSPickUpAddress className={css.pickupAddress} UPSPickUpAddress={UPSPickUpAddress} />
    </div>
  );

  const returnInstructionsSection = (
    <ReturnInstructionsSection
      checked={labelDelivery === PROVIDE_LABEL_OPTIONS.PICKUP}
      displayOnly={displayOnly}
      showInstructions={showInstructions}
      showInstructionsHandler={showInstructionsHandler}
      value={PROVIDE_LABEL_OPTIONS.PICKUP}
      storeIcon={BoxIcon}
    />
  );

  const optionInformation = (
    <>
      <div className={css.pickupAdditionalInfo}>
        <div className={css.pickupAdditionalInfoLeftCol}>
          <p>Shipping box required but no label needed</p>
          <p className={cn(css.optionInfo, { [css.checkedOptionInfo]: checked })}>
            UPS will pick up your return at your address. Please be home for them to retrieve your package.
          </p>
        </div>
        {checked && expandedInfo}
      </div>
    </>
  );

  return (
    <ReturnLabelOption
      checked={checked}
      children={returnInstructionsSection}
      icon={BoxIcon}
      id={PROVIDE_LABEL_OPTIONS.PICKUP}
      optionTitle="Pick-up by UPS"
      optionInformation={optionInformation}
      onReturnMethodSelect={onReturnMethodSelect}
      showInstructions={showInstructions}
      showInstructionsHandler={showInstructionsHandler}
      value={PROVIDE_LABEL_OPTIONS.PICKUP}
      displayOnly={displayOnly}
      UPSPickUpAddress={UPSPickUpAddress}
    />
  );
};

export default PickupOption;
